import React, { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import { Box, Modal, Tooltip, Typography } from "@mui/material";
import { BarLoader } from "react-spinners";
import { IoMdClose } from "react-icons/io";

import PDF from "../image/PDF.png";
import ID_CARD from "../image/ID_CARD.png";
import XLSX_ICON from "../image/XLS.png";
import { FaIdCard } from "react-icons/fa";
import DescriptionIcon from "@mui/icons-material/Description";

function ContractorAccount() {
  const userdata = JSON.parse(localStorage.getItem("userData"));
  const [accountinfo, setAccountinfo] = useState(null);

  const [isLoader, setIsLoader] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [showDocuments, setShowDocuments] = React.useState(false);
  const [viewReport, setViewReport] = React.useState(false);
  const [fileError, setFileError] = React.useState("");
  const controllerRef = React.useRef(null);
  const [showAll, setShowAll] = React.useState(false);

  const [modalTitle, setModalTitle] = useState("");

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  const RequiredFields = {
    user_name: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    contact_info: "",
    email: "",
    ...(userdata.role !== "Owner" && {
      cmp_found_year: "",
      no_of_employes: "",
      accountname: "",
      bankname: "",
      acnum: "",
    }),
  };

  const getAccountinfo = async () => {
    try {
      const res = await axios.get("/cvault/get-account-info/");
      const userDetails = res?.data?.details?.user_detail;
      const bankingDetails = res?.data?.details?.banking_detail;

      setAccountinfo({
        user_name: userDetails?.user_name || "",
        address: userDetails?.address || "",
        city: userDetails?.city || "",
        state: userDetails?.state || "",
        zip_code: userDetails?.zip_code || "",
        contact_info: userDetails?.contact_info || "",
        email: userDetails?.email || "",
        accountname: bankingDetails?.acc_holder_name || "",
        bankname: bankingDetails?.bank_name || "",
        acnum: bankingDetails?.acc_number || "",
        routing_number: bankingDetails?.routing_number || "",
        company_name: userDetails?.company_name || "",
        no_of_employes: userDetails?.no_of_employes || "",
        cmp_found_year: userDetails?.cmp_found_year || "",
        co_owner: userDetails?.co_owner_name || "",
        certificates: userDetails?.certificates || "",
        formation_document: bankingDetails?.formation_document || "",
        photo_id: bankingDetails?.photo_id || "",
        ein_confirmation_letter: bankingDetails?.ein_confirmation_letter || "",
        irs_form: bankingDetails?.irs_form || "",
        kyc_ownership_certificate:
          bankingDetails?.kyc_ownership_certificate || "",
        additional_documents: bankingDetails?.additional_document || "",
      });
    } catch (error) {
      console.log(error);
      toast.error("Please try again later");
    }
  };

  const handleFileClick = () => {
    console.log("hi");
  };

  const getBankinfo = async (values) => {
    const accountinfo = {
      user_detail: {
        user_name: values.user_name,
        address: values.address,
        city: values.city,
        email: values.email,
        no_of_employes: values.no_of_employes,
        cmp_found_year: values.cmp_found_year,
        contact_info: values.contact_info,
        state: values.state,
        zip_code: values.zip_code,
        co_owner_name: values.co_owner,
      },
      banking_detail: {
        bank_name: values.bankname || "",
        acc_holder_name: values.accountname || "",
        acc_number: values.acnum || "",
        routing_number: values.routing_number || "",
      },
    };

    try {
      await axios.post("/cvault/edit-account-info/", accountinfo, { headers });
      getAccountinfo();
      toast.success("User Updated Successfully");
    } catch (error) {
      console.log(error);
      toast.error("Please try again later");
    }
  };

  useEffect(() => {
    getAccountinfo();
  }, []);

  const viewFiles = async (file, iframeShow = false, title) => {
    iframeShow && setShowDocuments(null);

    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);
      setIsLoader(false);
      setViewReport(true);
      setModalTitle(title);
      setFileError("");

      const downloadFile = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();

        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };

      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data); // For displaying inline preview
          } else {
            setViewReport(false);

            downloadFile(response); // For unsupported file types, download the file
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            // setContractDocuments(true);
            // setSelectedContractDoc(response.data.base64_content); // Set the file to preview
          } else {
            setViewReport(false);

            downloadFile(response); // Download unsupported files
          }
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setLoader(false);
        setFileError("");
      } else {
        setLoader(false);
        setIsLoader(false);
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        toast.error(
          error?.response?.data?.error || "File not found in cloud storage"
        );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
      }
    }
  };
  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "70%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };
  return (
    <div className="p-3">
      <div className="d-flex justify-content-between mx-4 mt-2">
        <h4 className="fw-bold">Account Information</h4>

        <button
          className="btn btn-cvault"
          onClick={() => {
            window.location.href =
              userdata.role === "Owner" ? "/owner" : "/contractor";
          }}
        >
          Back
        </button>
      </div>

      <div className="row p-3 mt-3">
        <div className="col-12">
          {accountinfo && (
            <Formik
              initialValues={accountinfo}
              validate={(values) => {
                const errors = {};
                Object.keys(RequiredFields)?.map((ele) => {
                  if (!values[ele]) errors[ele] = "Required";
                });
                if (!values.email) {
                  errors.email = "Required";
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = "Invalid email address";
                }
                return errors;
              }}
              onSubmit={(values) => getBankinfo(values)}
            >
              {({ values, handleChange, handleBlur, handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  {/* Personal Info Section */}
                  <div className="card p-4 card-cvault mb-4">
                    <h5 className="fw-bold mb-4">Personal Information</h5>
                    <div className="row">
                      <div className="col-md-3 mb-2">
                        <div className="form-group mb-2">
                          <label>Email</label>
                          <input
                            readOnly={true}
                            className="form-control modern-input"
                            name="email"
                            type="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                          />
                          <ErrorMessage
                            className="text-danger small"
                            name="email"
                            component="div"
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-2">
                        <div className="form-group mb-2">
                          <label>
                            {userdata.role === "Owner"
                              ? "Owner Name"
                              : "User Name"}
                          </label>
                          <input
                            readOnly={true}
                            className="form-control modern-input"
                            name="user_name"
                            placeholder="Enter Your Name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.user_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-2">
                        <div className="form-group mb-2">
                          <label>Phone</label>
                          <input
                            readOnly={true}
                            className="form-control modern-input"
                            name="contact_info"
                            placeholder="Enter Phone Number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.contact_info}
                          />
                        </div>
                      </div>

                      <div className="col-md-3 mb-2">
                        <div className="form-group mb-2">
                          <label>Address</label>
                          <input
                            readOnly={true}
                            className="form-control modern-input"
                            name="address"
                            placeholder="Enter Address"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.address}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 mb-2">
                        <label>City</label>
                        <input
                          readOnly={true}
                          className="form-control modern-input"
                          name="city"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                        />
                      </div>
                      <div className="col-md-3 mb-2">
                        <label>State</label>
                        <input
                          readOnly={true}
                          className="form-control modern-input"
                          name="state"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.state}
                        />
                      </div>
                      <div className="col-md-3 mb-2">
                        <label>Zip Code</label>
                        <input
                          readOnly={true}
                          className="form-control modern-input"
                          name="zip_code"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.zip_code}
                        />
                      </div>
                      {userdata.role === "Owner" && (
                        <div className="col-md-3 mb-3">
                          <div className="form-group mb-2">
                            <label>Co-Owner Name</label>
                            <input
                              readOnly={true}
                              className="form-control modern-input"
                              name="co_owner"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.co_owner}
                            />
                          </div>
                        </div>
                      )}

                      {/* Photo ID */}
                      <div className="col-md-3 mb-4">
                        <div className="form-group mb-2">
                          <label className="form-label w-100">Photo ID</label>
                          {values.photo_id ? (
                             <div
                                          className=" relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl"
                                          style={{
                                            width: "150px",
                                            display: "flex",
                                            border: " 1px solid lightgray",
                                            borderRadius: " 4px",
                                            alignItems: "center",
                                            padding: "5px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div className="d-flex align-items-center g-2">
                            <Tooltip title={"Click here to view"}>
                              <div
                                style={{
                                  display: "flex",
                                  // flexDirection: "column",
                                  alignItems: "center",
                                  // width: "80px",
                                  gap: "10px",
                                  cursor: "pointer",
                                }}
                                // className="mt-2"
                                onClick={() =>
                                  viewFiles(values.photo_id, true, "Photo ID")
                                }
                              >
                                {/* File icon based on type */}
                                {/* <img
                                              src={ID_CARD}
                                              alt="file"
                                              style={{
                                                width: "42px",
                                                height: "42px",
                                                marginBottom: "4px",
                                              }}
                                            /> */}
                                <DescriptionIcon
                                  style={{ fontSize: 26, color: "#F5AE41" }}
                                />

                                {/* File name */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#1f1f1fff",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    wordBreak: "break-word",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {(() => {
                                    const fileName = values.photo_id
                                      .split("/")
                                      .pop(); // e.g., "driver_license_front.pdf"
                                    if (fileName.length > 8) {
                                      return `${fileName.slice(
                                        0,
                                        8
                                      )}...${fileName.slice(-4)}`;
                                    }
                                    return fileName;
                                  })()}
                                </Typography>
                              </div>
                            </Tooltip>
                            </div>
                            </div>
                          ) : (
                            <span className="text-muted small">
                              Not uploaded
                            </span>
                          )}
                        </div>
                      </div>

                      {userdata.role !== "Contractor" && (
                        <div className="col-md-9 mb-4">
                          <div className="form-group mb-2">
                            <label className="form-label w-100">
                              Additional Documents
                            </label>
                            {values.additional_documents ? (
                              Array.isArray(values.additional_documents) &&
                              values.additional_documents.length > 0 ? (
                                <>
                                  <div
                                    className="d-flex align-items-center flex-wrap"
                                    style={{ gap: "20px" }}
                                  >
                                    {(showAll
                                      ? values.additional_documents
                                      : values.additional_documents.slice(0, 3)
                                    ).map((file, idx) => {
                                      const fileName = file.split("/").pop(); // e.g. "report.pdf"
                                      const ext = fileName.split(".").pop(); // e.g. "pdf"
                                      const nameWithoutExt = fileName.replace(
                                        `.${ext}`,
                                        ""
                                      );
                                      const displayName =
                                        nameWithoutExt.length > 15
                                          ? `${nameWithoutExt.slice(
                                              0,
                                              8
                                            )}...${ext}`
                                          : fileName;

                                      return (
                                         <div
                                          className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl"
                                          style={{
                                            width: "150px",
                                            display: "flex",
                                            border: " 1px solid lightgray",
                                            borderRadius: " 4px",
                                            alignItems: "center",
                                            padding: "5px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div className="d-flex align-items-center g-2">
                                        <Tooltip title={"Click here to view"}>
                                          <div
                                            key={idx}
                                            style={{
                                              display: "flex",
                                              // flexDirection: "column",
                                              alignItems: "center",
                                              // width: "80px",
                                              gap: "10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              viewFiles(
                                                file,
                                                true,
                                                "Additional Documents"
                                              )
                                            }
                                          >
                                            {/* File icon based on type */}
                                            {/* <img
                                              src={
                                                file.endsWith(".pdf")
                                                  ? PDF
                                                  : file.endsWith(".xlsx") ||
                                                    file.endsWith(".xls")
                                                  ? XLSX_ICON
                                                  : "/FILE_ICON"
                                              }
                                              alt="file"
                                              style={{
                                                width: "42px",
                                                height: "42px",
                                                marginBottom: "4px",
                                              }}
                                            /> */}

                                            <DescriptionIcon
                                              style={{
                                                fontSize: 26,
                                                color: "#F5AE41",
                                              }}
                                            />

                                            {/* File name */}
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                color: "#1f1f1fff",
                                                textAlign: "center",
                                                fontSize: "13px",
                                                wordBreak: "break-word",
                                                maxWidth: "100%",
                                              }}
                                            >
                                              {displayName}
                                            </Typography>
                                          </div>
                                        </Tooltip>
                                        </div>
                                        </div>
                                      );
                                    })}
                                  </div>

                                  {/* Show "View All" / "View Less" toggle if more than 3 */}
                                  {values.additional_documents.length > 3 && (
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowAll(!showAll);
                                      }}
                                      style={{
                                        color: "#0d6efd",
                                        cursor: "pointer",
                                        marginTop: "4px",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                      }}
                                    >
                                      {showAll
                                        ? "View Less"
                                        : `View All (${values.additional_documents.length-2})`}
                                    </div>
                                  )}
                                </>
                              ) : (
                                "—"
                              )
                            ) : (
                              <span className="text-muted small">
                                Not uploaded
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Company Info */}
                  {userdata.role !== "Owner" && (
                    <div className="card p-4 card-cvault mb-4">
                      <h5 className="fw-bold mb-4">Business Information</h5>
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <div className="form-group mb-2">
                            <label>Company Name</label>
                            <input
                              readOnly={true}
                              className="form-control modern-input"
                              name="company_name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.company_name}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div className="form-group mb-2">
                            <label>Number of Employees</label>
                            <input
                              readOnly={true}
                              className="form-control modern-input"
                              name="no_of_employes"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.no_of_employes}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 mb-3">
                          <div className="form-group mb-2">
                            <label>Founded Year</label>
                            <input
                              readOnly={true}
                              className="form-control modern-input"
                              name="cmp_found_year"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.cmp_found_year}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
                          <div className="form-group mb-2">
                            <label>Contractor License Information</label>
                            <input
                              readOnly={true}
                              className="form-control modern-input"
                              name="certificates"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.certificates}
                            />
                          </div>
                        </div>
                        {/* EIN Confirmation Letter */}
                        <div className="col-md-9 mb-4">
                          <div className="form-group mb-2">
                            <label className="form-label w-100">
                              Additional Documents
                            </label>
                            {values.additional_documents ? (
                              Array.isArray(values.additional_documents) &&
                              values.additional_documents.length > 0 ? (
                                <>
                                  <div
                                    className="d-flex align-items-center flex-wrap"
                                    style={{ gap: "20px" }}
                                  >
                                    {(showAll
                                      ? values.additional_documents
                                      : values.additional_documents.slice(0, 3)
                                    ).map((file, idx) => {
                                      const fileName = file.split("/").pop(); // e.g. "report.pdf"
                                      const ext = fileName.split(".").pop(); // e.g. "pdf"
                                      const nameWithoutExt = fileName.replace(
                                        `.${ext}`,
                                        ""
                                      );
                                      const displayName =
                                        nameWithoutExt.length > 15
                                          ? `${nameWithoutExt.slice(
                                              0,
                                              8
                                            )}...${ext}`
                                          : fileName;

                                      return (
                                         <div
                                          className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-2xl"
                                          style={{
                                            width: "150px",
                                            display: "flex",
                                            border: " 1px solid lightgray",
                                            borderRadius: " 4px",
                                            alignItems: "center",
                                            padding: "5px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div className="d-flex align-items-center g-2">
                                        <Tooltip title={"Click here to view"}>
                                          <div
                                            key={idx}
                                            style={{
                                              display: "flex",
                                              // flexDirection: "column",
                                              alignItems: "center",
                                              // width: "80px",
                                              gap: "10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              viewFiles(
                                                file,
                                                true,
                                                "Additional Documents"
                                              )
                                            }
                                          >
                                            {/* File icon based on type */}
                                            {/* <img
                                              src={
                                                file.endsWith(".pdf")
                                                  ? PDF
                                                  : file.endsWith(".xlsx") ||
                                                    file.endsWith(".xls")
                                                  ? XLSX_ICON
                                                  : "/FILE_ICON"
                                              }
                                              alt="file"
                                              style={{
                                                width: "42px",
                                                height: "42px",
                                                marginBottom: "4px",
                                              }}
                                            /> */}

                                            <DescriptionIcon
                                              style={{
                                                fontSize: 26,
                                                color: "#F5AE41",
                                              }}
                                            />

                                            {/* File name */}
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                color: "#1f1f1fff",
                                                textAlign: "center",
                                                fontSize: "13px",
                                                wordBreak: "break-word",
                                                maxWidth: "100%",
                                              }}
                                            >
                                              {displayName}
                                            </Typography>
                                          </div>
                                        </Tooltip>
                                        </div>
                                        </div>
                                      );
                                    })}
                                  </div>

                                  {/* Show "View All" / "View Less" toggle if more than 3 */}
                                  {values.additional_documents.length > 3 && (
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setShowAll(!showAll);
                                      }}
                                      style={{
                                        color: "#0d6efd",
                                        cursor: "pointer",
                                        marginTop: "4px",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                      }}
                                    >
                                      {showAll
                                        ? "View Less"
                                        : `View All (${values.additional_documents.length-2})`}
                                    </div>
                                  )}
                                </>
                              ) : (
                                "—"
                              )
                            ) : (
                              <span className="text-muted small">
                                Not uploaded
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Bank Info */}
                  {values.routing_number &&
                    values.acnum &&
                    values.bankname &&
                    values.accountname && (
                      <div className="card p-4 card-cvault mb-4">
                        <h5 className="fw-bold mb-4">Bank Information</h5>
                        <div className="row">
                          {values.accountname && (
                            <div className="col-md-3 mb-3">
                              <div className="form-group mb-2">
                                <label>Account Holder's Name</label>
                                <input
                                  readOnly={true}
                                  className="form-control modern-input"
                                  name="accountname"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.accountname}
                                />
                              </div>
                            </div>
                          )}
                          {values.bankname && (
                            <div className="col-md-3 mb-3">
                              <div className="form-group mb-2">
                                <label>Bank Name</label>
                                <input
                                  readOnly={true}
                                  className="form-control modern-input"
                                  name="bankname"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.bankname}
                                />
                              </div>
                            </div>
                          )}
                          {values.acnum && (
                            <div className="col-md-3 mb-3">
                              <div className="form-group mb-2">
                                <label>Account Number</label>
                                <input
                                  readOnly={true}
                                  className="form-control modern-input"
                                  name="acnum"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.acnum}
                                />
                              </div>
                            </div>
                          )}
                          {values.routing_number && (
                            <div className="col-md-3 mb-3">
                              <div className="form-group mb-2">
                                <label>Routing Number</label>
                                <input
                                  readOnly={true}
                                  className="form-control modern-input"
                                  name="routing_number"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.routing_number}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                </Form>
              )}
            </Formik>
          )}
        </div>
      </div>

      <Modal
        open={viewReport}
        onClose={() => {
          setShowDocuments(null);
          setFileError("");
          setViewReport(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, top: "50%", height: "85%" }}>
          <div className="h-100">
            {showDocuments && (
              <div
                style={{
                  padding: "0px 10px",
                  width: "100%",
                  height: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <label className="" style={{ fontSize: "14px" }}>
                    {modalTitle} :{" "}
                    <span className="text-primary">
                      {showDocuments.file_name}
                    </span>
                  </label>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowDocuments(null);
                      setFileError("");
                      setViewReport(false);
                    }}
                  >
                    <IoMdClose fontSize={"20px"} />
                  </span>
                </div>

                {/* Image preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                    showDocuments.file_name
                  ) && (
                    <img
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "75vh",
                      }}
                      src={showDocuments.base64_content}
                      alt="Document preview"
                    />
                  )}

                {/* PDF preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(pdf)$/i.test(showDocuments.file_name) && (
                    <iframe
                      style={{ width: "100%", height: "75vh" }}
                      src={showDocuments.base64_content}
                    ></iframe>
                  )}

                {/* Video preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                    showDocuments.file_name
                  ) && (
                    <video
                      style={{ width: "100%", height: "75vh" }}
                      controls
                      src={showDocuments.base64_content}
                    ></video>
                  )}

                {/* Text preview */}
                {typeof showDocuments.base64_content === "string" &&
                  /\.(txt)$/i.test(showDocuments.file_name) && (
                    <iframe
                      style={{ width: "100%", height: "75vh" }}
                      src={showDocuments.base64_content}
                    ></iframe>
                  )}
              </div>
            )}

            {fileError !== "" && (
              <div className="text-danger text-center">{fileError}</div>
            )}
          </div>
        </Box>
      </Modal>
      {isLoader && (
        <div className="loader-overlay">
          <span className="loader-message">
            Fetching document from cloud storage. Please wait...
          </span>

          <BarLoader
            color="#F5AE41"
            width={"80%"}
            height={5}
            className="loader"
            loading={isLoader}
          />
        </div>
      )}
    </div>
  );
}

export default ContractorAccount;
